import React from 'react';
import Select from 'react-select';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import moment from 'moment';

const RESET = 'RESET';

const getItemStyle = (isDragging, draggableStyle, isHeader) => ({
    userSelect: "none",
    padding: '5px',
    border: '1px solid #CCC',
    margin: '0',
    fontSize: isHeader ? '.95em' : '.9em',
    background: isDragging ? "#CCC" : "#FFF",
    gridTemplateColumns: isHeader && "25px 25px .5fr .5fr 2fr 100px 25px",
    whiteSpace: "nowrap",
    ...draggableStyle
});

const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? "#f5f5f5" : "#f5f5f5",
    padding: '0'
});

const selectStyles = {
    option: (base, state) => ({
        ...base,
        fontSize: '0.8em',
    }),
    control: (base) => ({
        ...base,
        padding: '1px',
        margin: 0,
        minHeight: 0,
        fontSize: '0.8em'
    }),
    dropdownIndicator: (base) => ({
        ...base,
        padding: '0px 8px'
    }),
    clearIndicator: (base) => ({
        ...base,
        padding: '0px 8px'
    }),
    singleValue: (base, state) => {
        return { ...base, };
    },
    menu: (base) => ({
        ...base,
        boxShadow: 'none'
    }),
    menuList: (base) => ({
        ...base,
        background: 'white',
        border: '1px solid gray',
        borderRadius: '5px'
    })
};

const allOptions = [{ label: "All Members", MemberID: "All Members" },
{ label: "All Delegates", MemberID: "All Delegates" },
{ label: "All Senators", MemberID: "All Senators" }]


export default class UpdatePatronageModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showPatronTypeChangeWarning: {}
        }

        this.handlePatronTypeChange = this.handlePatronTypeChange.bind(this);
        this.cancel = this.cancel.bind(this);
        this.resetWarning = this.resetWarning.bind(this);
        this.isPassedHouse = this.isPassedHouse.bind(this);
        this.isPassedSenate = this.isPassedSenate.bind(this);
    }

    handlePatronTypeChange(row, val, confirm) {
        const patronDisplayName = row.PatronDisplayName;
        if (val && val.Name === "Chief Co-Patron" && this.props.patronList.filter(p => !p.RemoveDate && p.Name === "Chief Co-Patron").length === (this.props.billText.ChamberCode === "S" ? 3 : 4)) {
            this.setState({
                showPatronTypeChangeWarning: {
                    ...this.state.showPatronTypeChangeWarning,
                    [patronDisplayName]: !confirm
                }
            })
            if (!confirm) {
                return;
            }
        } else if (val === RESET) {
            this.setState({
                showPatronTypeChangeWarning: {
                    ...this.state.showPatronTypeChangeWarning,
                    [patronDisplayName]: false
                }
            })
            return;
        }
        this.props.handlePatronChange(row, 'PatronType', val)
    }

    cancel() {
        this.props.history.goBack();
    }

    resetWarning(patronDisplayName) {
        let showPatronTypeChangeWarning = { ...this.state.showPatronTypeChangeWarning };
        showPatronTypeChangeWarning[patronDisplayName] = false;

        this.setState({
            showPatronTypeChangeWarning
        })
    }

    isPassedHouse(history) {
        switch (this.props.billText.LegislationChamberCode + this.props.billText.LegislationTypeCode) {
            case "HB":
                if (history.find(x => ["H5000", "H5001"].includes(x.EventCode))) {
                    return true;
                } else {
                    return false;
                }
            case "HJ":
                if (history.find(x => ["H5003", "H5005"].includes(x.EventCode))) {
                    return true;
                } else {
                    return false;
                }
            case "HR":
                if (history.find(x => ["H5003", "H5005"].includes(x.EventCode))) {
                    return true;
                } else {
                    return false;
                }
            case "SB":
                if (history.find(x => ["H5100", "S5430", "S5431", "S5432", "S5433", "S5434"].includes(x.EventCode))
                    || (history.find(x => x.EventCode === "S6015") && history.find(x => x.EventCode === "H6015"))) {
                    return true;
                } else {
                    return false
                }
            case "SJ":
                if (history.find(x => ["H5110", "H5130", "S5430", "S5431", "S5432", "S5433", "S5434"].includes(x.EventCode))) {
                    return true;
                } else {
                    return false;
                }
            default:
                return false;
        }
    }

    isPassedSenate(history) {
        switch (this.props.billText.LegislationChamberCode + this.props.billText.LegislationTypeCode) {
            case "SB":
                if (history.find(x => ["S5000", "S5001"].includes(x.EventCode))) {
                    return true;
                } else {
                    return false;
                }
            case "SJ":
                if (history.find(x => ["S5003", "S5005"].includes(x.EventCode))) {
                    return true;
                } else {
                    return false;
                }
            case "SR":
                if (history.find(x => ["S5003", "S5005", "S5122"].includes(x.EventCode))) {
                    return true;
                } else {
                    return false;
                }
            case "HB":
                if (history.find(x => ["S5100", "H5430", "H5431", "H5432", "H5433", "H5434"].includes(x.EventCode))
                    || (history.find(x => x.EventCode === "S6015") && history.find(x => x.EventCode === "H6015"))) {
                    return true;
                } else {
                    return false;
                }
            case "HJ":
                if (history.find(x => ["S5130", "S5110", "H5430", "H5431", "H5432", "H5433", "H5434"].includes(x.EventCode))) {
                    return true
                } else {
                    return false
                }
            default:
                return false;
        }
    }

    componentDidMount() {
        this.props.getBillHistory("?LegislationId=" + this.props.billText.LegislationID + "&sessionCode=" + this.props.billText.SessionCode, true)
            .then(() => {
                this.setState({
                    passedHouse: this.isPassedHouse(this.props.billHistory),
                    passedSenate: this.isPassedSenate(this.props.billHistory)
                })
            })
    }

    render() {
        const { billText, patronList, memberList, patronTypes, newPatron } = this.props;
        const { showPatronTypeChangeWarning } = this.state;
        const showConfirmButton = newPatron?.length && !newPatron.find(p => !p.MemberID) && !newPatron.find(p => !memberList.find(m => m.MemberID === p.MemberID)) && !newPatron.find(p => !patronTypes.find(pt => pt.Name === p.Name)) && [...newPatron].filter(p => p.Name === "Chief Co-Patron").concat(patronList.filter(p => !p.RemoveDate && p.Name === "Chief Co-Patron")).length > (this.props.billText.ChamberCode === "S" ? 3 : 4);

        let disabledMessage = "";

        const isAddDisabled = () => {
            if (showConfirmButton
                || !newPatron?.length
                || !newPatron[0].Name
                || !newPatron[0].MemberID
                || newPatron.find(p => !memberList.find(m => m.MemberID === p.MemberID))
                || newPatron.find(p => !patronTypes.find(pt => pt.Name === p.Name))
                || (patronList.filter(x => x.PatronTypeID === 2).length >= (this.props.billText.ChamberCode === "S" ? 3 : 4) && this.props.newPatron.PatronTypeID === 2)
            ) {
                return true;
            } else if (this.state.passedHouse && this.state.passedSenate) {
                disabledMessage = "Cannot add patrons to passed legislation";
                return true;
            } else if (this.state.passedSenate
                && ["SB", "SR"].includes((this.props.billText.ChamberCode + this.props.billText.LegislationTypeCode))
                && newPatron.find(x => x.ChamberCode === "S")) {
                disabledMessage = "Cannot add senators to passed Senate legislation";
                return true;
            } else if (this.state.passedHouse
                && ["HB", "HR"].includes((this.props.billText.ChamberCode + this.props.billText.LegislationTypeCode))
                && newPatron.find(x => x.ChamberCode === "H")) {
                disabledMessage = "Cannot add delegates to passed House legislation";
                return true;
            } else if ((this.props.billText.ChamberCode + this.props.billText.LegislationTypeCode) === "HR"
                && newPatron.find(x => x.ChamberCode === "S")) {
                disabledMessage = "Cannot add senators to House resolutions";
                return true;
            } else if ((this.props.billText.ChamberCode + this.props.billText.LegislationTypeCode) === "SR"
                && newPatron.find(x => x.ChamberCode === "H")) {
                disabledMessage = "Cannot add delegates to Senate resolutions";
                return true;
            } else if (this.props.newPatron.find(x => x.PatronTypeID === 1) && this.props.patronList.find(x => x.PatronTypeID === 1)) {
                disabledMessage = "Cannot have more than one chief patron.";
                return true;
            } else {
                disabledMessage = "";
            }
        }

        const buildAuditText = (auditList) => {
            let mostRecent = auditList ? auditList[0] : "";

            switch (mostRecent.ChangeType) {
                case "Moved":
                    return String("Moved " + moment(mostRecent.ModifyDate).format("MM/DD/YYYY hh:mm A"));
                case "Added":
                    return String("Added " + moment(mostRecent.ModifyDate).format("MM/DD/YYYY hh:mm A"));
                case "Deleted":
                    return String("Removed " + moment(mostRecent.ModifyDate).format("MM/DD/YYYY hh:mm A"));
                default:
                    return "";
            }
        }

        return (
            <div>
                <div style={{ margin: '10px' }}>
                    <div style={{ marginBottom: '10px', display: "flex", whiteSpace: "nowrap" }}>
                        <h2 style={{ marginBottom: '0px' }}>Update Patrons ({billText.LegislationNumber})</h2>
                        <div style={{ width: "100%" }} />
                        <span style={{ marginTop: "30px", color: "#c0392b" }}>{this.props.patronsReordered ? "Patrons Not In Default Order" : ""}</span>
                    </div>
                    <div style={{ marginBottom: '10px' }}>
                        <div style={{ display: 'grid', gap: '10px', gridTemplateColumns: '100px 1fr 150px 100px', alignItems: 'center' }}>
                            <span style={{ fontSize: '.85em' }}>New Patron(s): </span>
                            <Select
                                isMulti
                                options={memberList ? allOptions.concat(memberList.filter(m => !patronList.map(p => p.MemberID).includes(m.MemberID))) : []}
                                onChange={(val, behavior) => this.props.handleNewPatronChange('Patron', val, behavior)}
                                getOptionValue={(opt) => opt.MemberID}
                                getOptionLabel={(opt) => memberList.find(m => m.MemberID === opt.MemberID)?.label ?? opt.label}
                                value={[...newPatron].filter(p => p.MemberID)}
                                styles={selectStyles}
                                classNamePrefix='no-width-dropdown-input'
                                closeMenuOnSelect={false}
                            />
                            <Select
                                options={patronTypes ? patronTypes.filter(pt => pt.Name !== "Incorporated Chief Co-Patron" || !newPatron.filter(p => p.ChamberCode !== "S")?.length) : []}
                                getOptionLabel={opt => opt.Name}
                                getOptionValue={opt => opt.PatronTypeID}
                                onChange={(val) => this.props.handleNewPatronChange('PatronType', val)}
                                value={newPatron[0].Name ? patronTypes.find(pt => pt.Name === newPatron[0].Name) : null}
                                styles={selectStyles}
                                classNamePrefix='no-width-dropdown-input'
                            />
                            <button disabled={isAddDisabled()} className="button primary" onClick={this.props.addNewPatron}>Add</button>
                        </div>
                        {showConfirmButton &&
                            <div style={{ display: 'flex', gap: '8px', marginTop: "10px" }}>
                                <span className="input-feedback-warning" style={{ fontSize: '13px', margin: 'auto 0px' }}>There can not be more than {this.props.billText.ChamberCode === "S" ? 3 : 4} Chief Co-Patrons.</span>
                                <button className="button secondary" onClick={() => this.props.resetPatrons(false)}>Remove Selection(s)</button>
                            </div>
                        }
                        <div style={{ display: "flow-root" }}>
                            {disabledMessage !== "" && <span style={{ float: "right", color: "#c0392b" }}>{disabledMessage}</span>}
                        </div>
                    </div>
                    <div style={getItemStyle(false, null, true)} className='inner-grid'>
                        <div />
                        <div>#</div>
                        <div>Display Name</div>
                        <div style={{ margin: 'auto' }}>Patron Type</div>
                        <div style={{ margin: 'auto' }}>Last Action</div>
                        <div style={{ margin: 'auto' }}>Introducing</div>
                        <div style={{ margin: 'auto' }}></div>
                    </div>
                    <DragDropContext onDragEnd={result => this.props.onDragEnd(result)}>
                        <Droppable droppableId={"hp"} index={0}>
                            {(provided, snapshot) => (
                                <div
                                    {...provided.droppableProps}
                                    ref={provided.innerRef}
                                    style={getListStyle(snapshot.isDraggingOver)}
                                >
                                    {patronList.map((row, j) => (
                                        <Draggable isDragDisabled={Boolean(row.RemoveDate)} key={row.MemberID + "-" + row.LegislationID} draggableId={row.MemberID.toString()} index={j}>
                                            {(provided, snapshot) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    style={getItemStyle(
                                                        snapshot.isDragging,
                                                        provided.draggableProps.style
                                                    )}
                                                >
                                                    <div style={{ alignItems: 'center', gridTemplateColumns: "25px 25px .5fr .5fr 2fr 100px 25px", color: row.RemoveDate ? '#8b8b8b' : '' }} className='inner-grid'>
                                                        <div><button className="button draggable">Drag and drop</button></div>
                                                        <div>{row.Sequence}</div>
                                                        <div>{row.PatronDisplayName + " (" + row.ChamberCode + ")"}</div>
                                                        <div>
                                                            <Select
                                                                options={patronTypes ? patronTypes.filter(pt => pt.Name !== "Incorporated Chief Co-Patron" || row.Name === "Incorporated Chief Co-Patron" || row.ChamberCode === "S") : []}
                                                                getOptionLabel={opt => opt.Name}
                                                                getOptionValue={opt => opt.PatronTypeID}
                                                                onChange={(val) => this.handlePatronTypeChange(row, val)}
                                                                value={patronTypes.find(p => p.Name === row.Name)}
                                                                isDisabled={row.RemoveDate}
                                                                styles={selectStyles}
                                                                classNamePrefix='no-width-dropdown-input'
                                                            />
                                                        </div>
                                                        <div>
                                                            <span style={{ fontSize: "14px" }}>{buildAuditText(row.PatronListChanges)}</span>
                                                        </div>
                                                        <div style={{ margin: 'auto' }} disabled={row.RemoveDate} onClick={() => this.props.handlePatronChange(row, 'IsIntroducing')} className="toggle-switch">
                                                            <input id="sr-status-change" checked={row.IsIntroducing} type="checkbox" />
                                                            <span className="slider"></span>
                                                        </div>
                                                        <div style={{ margin: 'auto', display: 'flex' }}><button onClick={() => this.props.togglePatron(row)} className={`icon ${row.RemoveDate ? 'add' : 'delete'}`} type="button" /></div>
                                                    </div>
                                                    {showPatronTypeChangeWarning[row.PatronDisplayName] &&
                                                        <div style={{ display: 'flex', gap: '8px' }}>
                                                            <span className="input-feedback-warning" style={{ fontSize: '13px', margin: 'auto 0px' }}>There can not be more than {this.props.billText.ChamberCode === "S" ? 3 : 4} Chief Co-Patrons.</span>
                                                            <button className="button secondary" onClick={() => this.resetWarning(row.PatronDisplayName)}>Dismiss</button>
                                                        </div>
                                                    }
                                                </div>
                                            )}
                                        </Draggable>
                                    ))}
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    </DragDropContext>
                </div>
                <div className="inline-list align-right" style={{ paddingBottom: '55px' }}>
                    {!this.props.savingPatrons && <button className="button secondary" onClick={this.cancel}>Cancel</button>}
                    <button disabled={this.props.savingPatrons || showConfirmButton || Object.keys(showPatronTypeChangeWarning).find(key => showPatronTypeChangeWarning[key] === true)} className="button primary" onClick={this.props.updatePatrons}>{this.props.savingPatrons ? <div className="small-spinner" /> : 'Update'}</button>
                </div>
            </div>
        )
    }
}
